import * as THREE from "three";
import { IVfxTask } from "../../core/runtime/vfx_task_runner.js";
import { Vfx3DRuntime } from "../../vfx_3d_runtime.js";
import { IController, StopBehavior } from "../../core/types/controller_types.js";
import { VfxShockwaveBatch } from "../../core/batches/vfx_shockwave_batch.js";
import { ResourceID } from "../../../resource_loader/resource_id.js";

export class VfxTableImpactTask implements IVfxTask, IController
{
  // --- Table Shockwave Constants (ShockwaveGlow6) ---
  private static readonly SHOCKWAVE_RES_ID      : ResourceID = ResourceID.ShockwaveGlow6;
  private static readonly SHOCKWAVE_LIFESPAN    : number     = 0.2;
  private static readonly SHOCKWAVE_MAX_SCALE   : number     = 1.5;
  private static readonly SHOCKWAVE_MAX_ALPHA   : number     = 0.6;
  private static readonly SHOCKWAVE_FADE_START  : number     = 0.2; // Момент початку спадання альфи (0.0..1.0)
  private static readonly SHOCKWAVE_DECEL_POWER : number     = 3; // Ступінь сповільнення розширення ударної хвилі (ease-out)

  public is_active    : boolean = true;
  private position    : THREE.Vector3;
  private start_time  : number;
  private has_spawned : boolean = false;

  public constructor( position: THREE.Vector3 )
  {
    this.position   = position.clone();
    this.start_time = Vfx3DRuntime.current_time;
  }

  public setPosition( pos: THREE.Vector3 ): void
  {
    this.position.copy( pos );
  }

  public stop( _behavior?: StopBehavior ): void
  {
    this.is_active = false;
  }

  public start(): void
  {
    this.is_active = true;
  }

  public accelerate( _factor: number ): void {}

  public onUpdate( now: number ): boolean
  {
    if ( !this.is_active )
      return true;

    if ( now < this.start_time )
      return false;

    const age = now - this.start_time;

    if ( !this.has_spawned )
    {
      this.has_spawned = true;
      this.spawnShockwave();
    }

    if ( age >= VfxTableImpactTask.SHOCKWAVE_LIFESPAN )
    {
      this.stop();
      return true;
    }

    return false;
  }

  private spawnShockwave(): void
  {
    const batch = Vfx3DRuntime.getBatch( VfxShockwaveBatch );

    batch.spawnParticle(
      VfxTableImpactTask.SHOCKWAVE_RES_ID,
      this.position,
      VfxTableImpactTask.SHOCKWAVE_MAX_SCALE,
      VfxTableImpactTask.SHOCKWAVE_LIFESPAN,
      this.start_time,
      VfxTableImpactTask.SHOCKWAVE_DECEL_POWER,
      VfxTableImpactTask.SHOCKWAVE_MAX_ALPHA,
      VfxTableImpactTask.SHOCKWAVE_FADE_START
    );
  }
}
